import * as React from "react";
import { Tabs, List } from "antd";
import * as InfiniteScroll from "react-infinite-scroller";
import { IconContext } from "react-icons";
import { MdEdit } from "react-icons/md";

import { GetProfileDetailsQuery_getProfileDetails } from "@bakbak/controller";

import { PostItemConnector } from "../../post/item/PostItemConnector";
import { DUMMY_PROFILE_PIC_URI } from "../../../constants";

interface Props {
  profile: GetProfileDetailsQuery_getProfileDetails;
  logout: () => void;
  onLogoutComplete: () => void;
  gotoPostDetails: (postId: string) => void;
  editProfile: () => void;
  updateLoggedUser: (profile: any) => void;
}

const TabPane = Tabs.TabPane;

export class ProfileView extends React.PureComponent<Props> {
  componentDidMount() {
    this.props.updateLoggedUser(this.props.profile);
  }
  onLogout = () => {
    this.props.logout();
    this.props.onLogoutComplete();
  };
  renderImage = () => {
    const { profile } = this.props;
    if (profile.pictureUrl) {
      return <img src={profile.pictureUrl} style={styles.imageStyle} />;
    } else {
      return (
        <img
          src={`${DUMMY_PROFILE_PIC_URI}${profile.userName}.png`}
          style={styles.imageStyle}
        />
      );
    }
  };
  renderImageAndSettings = () => {
    const { profile, editProfile } = this.props;
    return (
      <div
        style={{
          marginTop: 30,
          display: "flex",
          flexDirection: "column",
          marginBottom: 40
        }}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          {this.renderImage()}
          <span style={{ marginLeft: 20, fontWeight: 600 }}>
            {profile.userName}
          </span>
        </div>
        <div
          style={{
            marginTop: 20,
            color: "blue",
            cursor: "pointer",
            marginLeft: -20
          }}
        >
          <div onClick={editProfile}>
            <IconContext.Provider
              value={{
                size: "1.2em",
                style: { verticalAlign: "middle" },
                color: "white"
              }}
            >
              <MdEdit /> Edit Profile
            </IconContext.Provider>
          </div>
        </div>
      </div>
    );
  };

  callback = (key: string) => {
    console.log(key);
  };

  renderStatusBar = () => {
    const { profile } = this.props;
    return (
      <Tabs defaultActiveKey="1" onChange={this.callback}>
        <TabPane
          tab={`${profile.posts ? profile.posts.length : 0} Posts`}
          key="1"
        >
          {this.renderPosts()}
        </TabPane>
        <TabPane disabled={true} tab={`${profile.score} Score`} key="2">
          {profile.score}
        </TabPane>
      </Tabs>
    );
  };
  renderPosts = () => {
    const { posts } = this.props.profile;
    return (
      <div style={{ marginTop: 10, marginLeft: 10 }}>
        <InfiniteScroll
          initialLoad={true}
          pageStart={0}
          useWindow={true}
          loadMore={() => null}
        >
          <List
            itemLayout="vertical"
            dataSource={posts}
            renderItem={this.renderItem}
          />
        </InfiniteScroll>
      </div>
    );
  };
  renderItem = (item: any) => {
    return <PostItemConnector post={item} />;
  };

  render() {
    return (
      <div style={{ marginLeft: 100 }}>
        {this.renderImageAndSettings()}
        {this.renderStatusBar()}
      </div>
    );
  }
}

const styles = {
  imageStyle: {
    borderRadius: 10,
    width: 80,
    height: 80,
    imageOrientation: "from-image"
  }
};



// WEBPACK FOOTER //
// ./src/modules/profile/find/ProfileView.tsx